
let loadingSpinner;
let overlay;
let showCount = 0;

function insertStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .loader {
            border: 0.125rem solid rgba(0, 0, 0, 0.1);
            border-radius: 50%;
            border-top: 0.125rem solid #3498db;
            width: 2rem;
            height: 2rem;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }

            100% {
                transform: rotate(360deg);
            }
        }

      .loading-spinner {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 5rem;
            height: 5rem;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 0.5rem;
            z-index: 10000;
            color: #fff;
            font-size: 0.875rem;
        }

      .loading-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0);
            z-index: 9999;
        }
    `;
    document.head.appendChild(style);
}

function createLoadingSpinner() {
    insertStyles();
    overlay = document.createElement('div');
    overlay.className = 'loading-overlay';
    document.body.appendChild(overlay);

    loadingSpinner = document.createElement('div');
    loadingSpinner.className = 'loading-spinner';

    const loader = document.createElement('div');
    loader.className = 'loader';
    loadingSpinner.appendChild(loader);

    const span = document.createElement('span');
    span.textContent = 'Loading...';
    loadingSpinner.appendChild(span);

    document.body.appendChild(loadingSpinner);
}

export function showLoadingSpinner() {
    if (showCount === 0) {
        if (!loadingSpinner) {
            createLoadingSpinner();
        } else {
            loadingSpinner.style.display = 'flex';
            overlay.style.display = 'block';
        }
    }
    showCount++;
}

export function hideLoadingSpinner() {
    showCount--;
    if (showCount === 0 && loadingSpinner) {
        loadingSpinner.style.display = 'none';
        overlay.style.display = 'none';
    }
}
